import { createGlobalStyle } from 'styled-components'
import tw, { GlobalStyles as BaseStyles } from 'twin.macro'

const CustomStyles = createGlobalStyle<{ dark?: boolean }>`
  @font-face {
    font-family: 'TT Commons';
    font-weight: 400;
    font-display: block;
    src: url(${process.env.PUBLIC_URL}/fonts/tt_commons_regular-webfont.woff2)
      format('woff2');
  }
  @font-face {
    font-family: 'TT Commons';
    font-weight: 500;
    font-display: block;
    src: url(${process.env.PUBLIC_URL}/fonts/tt_commons_medium-webfont.woff2)
      format('woff2');
  }
  @font-face {
    font-family: 'TT Commons';
    font-weight: 600;
    font-display: block;
    src: url(${process.env.PUBLIC_URL}/fonts/tt_commons_demibold-webfont.woff2)
      format('woff2');
  }

  body {
    background-color: ${tw`bg-default-subdued`};
    ${(props) => (props.dark ? tw`dark` : '')}
  }
`

function GlobalStyles({ dark }: { dark?: boolean }) {
  return (
    <>
      <BaseStyles />
      <CustomStyles dark={dark} />
    </>
  )
}

export default GlobalStyles
